/**
 * O que aconteceu com o e-mail de boas-vindas da conta Google (2026-10-27),
 * que sai ao criar o acesso e a cada "Reenviar convite".
 *
 * Espelho de `core.vocabulary.WELCOME_EMAIL_OUTCOMES` (o `core/` é o dono;
 * paridade por FONTE em `tests/test_welcome_email_parity.py`). `null` na
 * resposta = não é o caso: a conta recebe o convite do Keycloak.
 */
export const WELCOME_EMAIL_OUTCOMES = ["sent", "simulated", "failed", "unavailable"] as const;

export type WelcomeEmailOutcome = (typeof WELCOME_EMAIL_OUTCOMES)[number];

/** A frase que a tela mostra a quem convidou. `failed` e `unavailable` são
 *  aviso: a conta foi criada, mas a pessoa não foi avisada por e-mail. */
export function welcomeEmailNotice(outcome: WelcomeEmailOutcome, email: string): string {
  switch (outcome) {
    case "sent":
      return `E-mail de boas-vindas enviado para ${email}.`;
    case "simulated":
      return `E-mail de boas-vindas simulado para ${email} (ambiente local, nada foi enviado).`;
    case "failed":
      return `O e-mail de boas-vindas para ${email} não saiu. Tente "Reenviar convite" ou avise a pessoa.`;
    case "unavailable":
      return `O envio de e-mail não está configurado neste ambiente: avise ${email} que o acesso foi criado.`;
  }
}
